"use strict";
import {
    HubConnectionBuilder,
    LogLevel,
    HttpTransportType
} from '@microsoft/signalr'
export default {
    install(Vue) {
        const connection = new HubConnectionBuilder()
            .withUrl('https://sock.larepublica.co/refresh', {
                transport: HttpTransportType.WebSockets,
                skipNegotiation: true
            })
            // .withUrl('http://dsock.larepublica.co:12344/refresh')
            .configureLogging(LogLevel.Error)
            .withAutomaticReconnect()
            .build();
        connection.serverTimeoutInMilliseconds = 1000 * 90;
        connection.keepAliveIntervalInMilliseconds = 1000 * 45;
        const refreshHub = new Vue();
        Vue.prototype.$refreshHub = refreshHub;
        connection.on('RefreshHome', () => {
            refreshHub.$emit('home-refreshed');
        });
        connection.on('RefreshLive', () => {
            refreshHub.$emit('live-update');
        });
        connection.on('LiveOn', () => {
            refreshHub.$emit('live-on');
        });

        connection.on('LiveOff', () => {
            refreshHub.$emit('live-off');
        });
        connection.on('AtentoUpdate', () => {
            refreshHub.$emit('atento-update');
        });
        connection.on('Pres2022_2', (data) => {
            refreshHub.$emit('pres-2022', data);
        });
        connection.on('Pres2022_2_Historic', (data) => {
            refreshHub.$emit('pres-2022-historic', data);
        });
        connection.on('Pres2022_2_State', (data) => {
            refreshHub.$emit('pres-2022-state', data);
        });
        connection.start();
    }
}